"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _objectSpread5 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactScroll = require("react-scroll");

var _reactFeather = require("react-feather");

var _queryString = _interopRequireDefault(require("query-string"));

var _jsFileDownload = _interopRequireDefault(require("js-file-download"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _relativeTime = _interopRequireDefault(require("dayjs/plugin/relativeTime"));

var _components = require("../components");

var _useWindowSize2 = _interopRequireDefault(require("../lib/utils/hooks/useWindowSize"));

var _useOnClickOutside = _interopRequireDefault(require("../lib/utils/hooks/useOnClickOutside"));

var _export = require("../lib/utils/helper/export");

var _Layout = require("./Layout.style");

var _reveleerLogo = _interopRequireDefault(require("../assets/images/logo/reveleer-logo.svg"));

var _logoMobile = _interopRequireDefault(require("../assets/images/logo/logo-mobile.svg"));

_dayjs.default.extend(_relativeTime.default);

var Sidebar = function Sidebar(_ref) {
  var expanded = _ref.expanded,
      setExpanded = _ref.setExpanded,
      originalFileName = _ref.originalFileName,
      documentTitle = _ref.documentTitle,
      rowsToExport = _ref.rowsToExport,
      resetRowsSelection = _ref.resetRowsSelection,
      rawDocument = _ref.rawDocument,
      currentDocument = _ref.currentDocument,
      ehrRecord = _ref.ehrRecord,
      exportCDAAsPDF = _ref.exportCDAAsPDF,
      exportCDAAsPDFLoading = _ref.exportCDAAsPDFLoading,
      setExportCDAAsPDFLoading = _ref.setExportCDAAsPDFLoading;
  var navigate = (0, _reactRouterDom.useNavigate)();

  var _useSearchParams = (0, _reactRouterDom.useSearchParams)(),
      _useSearchParams2 = (0, _slicedToArray2.default)(_useSearchParams, 2),
      searchParams = _useSearchParams2[0],
      setSearchParams = _useSearchParams2[1];

  var _useWindowSize = (0, _useWindowSize2.default)(),
      width = _useWindowSize.width;

  var sidebarRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      menuHover = _useState2[0],
      setMenuHover = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isAttachment = _useState4[0],
      setIsAttachment = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      exportAllButtonExpanded = _useState6[0],
      setExportAllButtonExpanded = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      rowsButtonExpanded = _useState8[0],
      setRowsButtonExpanded = _useState8[1]; // const exportCDAAsPDFLoading = {
  //   1: false,
  //   2: false,
  //   3: false,
  //   4: false
  // };


  var exportAsPDF = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(config, id) {
      var conf;
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setExportCDAAsPDFLoading((0, _objectSpread5.default)((0, _objectSpread5.default)({}, exportCDAAsPDFLoading), {}, (0, _defineProperty2.default)({}, id, true)));
              conf = config ? config : {};
              _context.prev = 2;
              _context.next = 5;
              return exportCDAAsPDF(conf);

            case 5:
              setExportCDAAsPDFLoading((0, _objectSpread5.default)((0, _objectSpread5.default)({}, exportCDAAsPDFLoading), {}, (0, _defineProperty2.default)({}, id, false)));
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);
              console.log('[exportAsPDF] error: ', _context.t0);
              setExportCDAAsPDFLoading((0, _objectSpread5.default)((0, _objectSpread5.default)({}, exportCDAAsPDFLoading), {}, (0, _defineProperty2.default)({}, id, false)));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 8]]);
    }));

    return function exportAsPDF(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var closeMobileMenu = (0, _react.useCallback)(function () {
    if (width < 1199) {
      setExpanded(false);
    }
  }, [width, setExpanded]);

  var downloadRecord = function downloadRecord() {
    var patientName = currentDocument.header['Patient Name'];
    var fileName = patientName;
    var blob = new Blob([rawDocument], {
      type: 'text/xml'
    });
    (0, _jsFileDownload.default)(blob, "".concat(fileName, ".xml"));
  };

  var downloadRowsAsXML = function downloadRowsAsXML(rawDocument, rowsToExport) {
    var exportedRowsString;
    exportedRowsString = (0, _export.exportRows)(rawDocument, rowsToExport);
    var patientName = currentDocument.header['Patient Name'];
    var fileName = "".concat(patientName);
    var blob = new Blob([exportedRowsString], {
      type: 'text/xml'
    });
    (0, _jsFileDownload.default)(blob, "".concat(fileName, ".xml"));
  };

  var rowsSum = function rowsSum(arr) {
    var sum = 0;
    arr.forEach(function (el) {
      return sum += el.rows.length;
    });
    return sum;
  };

  (0, _react.useEffect)(function () {
    closeMobileMenu();

    var _queryString$parse = _queryString.default.parse(searchParams.toString()),
        attachment = _queryString$parse.attachment;

    if (attachment) {
      setIsAttachment(true);
    } else {
      setIsAttachment(false);
    }
  }, [width, closeMobileMenu]);
  (0, _useOnClickOutside.default)(sidebarRef, function () {
    return closeMobileMenu();
  });
  var tocData = currentDocument.body.map(function (section) {
    return section.title;
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Layout.SidebarWrapper, {
    expanded: expanded,
    menuHover: menuHover,
    onMouseEnter: function onMouseEnter() {
      return setMenuHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setMenuHover(false);
    },
    className: expanded ? 'open' : '',
    ref: sidebarRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sidebar-header"
  }, isAttachment ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, expanded ? /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: "Go Back",
    className: "flex",
    onClick: function onClick() {
      return window.history.back();
    },
    icon: /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronLeft, null)
  }) : menuHover ? /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: "Go Back",
    className: "flex",
    onClick: function onClick() {
      return window.history.back();
    },
    icon: /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronLeft, null)
  }) : /*#__PURE__*/_react.default.createElement("img", {
    src: _logoMobile.default,
    alt: "Reveleer Logo"
  })) : /*#__PURE__*/_react.default.createElement("img", {
    src: expanded ? _reveleerLogo.default : menuHover ? _reveleerLogo.default : _logoMobile.default,
    alt: "Reveleer Logo",
    onClick: function onClick() {
      return navigate('/');
    }
  }), /*#__PURE__*/_react.default.createElement(_reactFeather.X, {
    onClick: function onClick() {
      return setExpanded(false);
    }
  })), expanded || menuHover ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "record-data"
  }, documentTitle || originalFileName ? /*#__PURE__*/_react.default.createElement("div", {
    className: "badge"
  }, documentTitle || originalFileName) : null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ehrRecord && ehrRecord.dataAsOf ? /*#__PURE__*/_react.default.createElement("div", {
    className: "badge green"
  }, "Data as of ", ehrRecord.dataAsOf) : null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: 'Export all rows',
    className: "small flex outline",
    icon: exportAllButtonExpanded ? /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronUp, null) : /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronDown, null),
    onClick: function onClick() {
      return setExportAllButtonExpanded(!exportAllButtonExpanded);
    }
  }), exportAllButtonExpanded ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ehrRecord ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: 'as PDF',
    className: "small outline flex sub",
    onClick: function onClick() {
      return exportAsPDF(null, 1);
    },
    icon: exportCDAAsPDFLoading && exportCDAAsPDFLoading[1] ? /*#__PURE__*/_react.default.createElement(_reactFeather.RotateCw, {
      style: {
        animation: "spin 1.5s linear infinite"
      }
    }) : /*#__PURE__*/_react.default.createElement(_reactFeather.Download, null),
    disabled: exportCDAAsPDFLoading && Object.keys(exportCDAAsPDFLoading).find(function (i) {
      return exportCDAAsPDFLoading[i] === true;
    })
  }), /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: 'as PDF with RAF',
    className: "small outline flex sub",
    onClick: function onClick() {
      return exportAsPDF({
        withRaf: true
      }, 2);
    },
    icon: exportCDAAsPDFLoading && exportCDAAsPDFLoading[2] ? /*#__PURE__*/_react.default.createElement(_reactFeather.RotateCw, {
      style: {
        animation: "spin 1.5s linear infinite"
      }
    }) : /*#__PURE__*/_react.default.createElement(_reactFeather.Download, null),
    disabled: exportCDAAsPDFLoading && Object.keys(exportCDAAsPDFLoading).find(function (i) {
      return exportCDAAsPDFLoading[i] === true;
    })
  })) : null, /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: 'as CCD XML',
    className: "small outline flex sub",
    onClick: function onClick() {
      return downloadRecord();
    },
    icon: /*#__PURE__*/_react.default.createElement(_reactFeather.Download, null),
    disabled: exportCDAAsPDFLoading && Object.keys(exportCDAAsPDFLoading).find(function (i) {
      return exportCDAAsPDFLoading[i] === true;
    })
  })) : null), ehrRecord && ehrRecord.hccCompendiumUrl ? /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: "View Compendium",
    className: "small outline lightblue",
    onClick: function onClick() {
      return window.open(ehrRecord.hccCompendiumUrl, '_blank');
    }
  }) : null))) : /*#__PURE__*/_react.default.createElement("h5", null, "..."), rowsToExport && rowsToExport.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: "export-buttons"
  }, expanded || menuHover ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: "Export ".concat(rowsSum(rowsToExport), " ").concat(rowsSum(rowsToExport) > 1 ? 'rows' : 'row'),
    icon: rowsButtonExpanded ? /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronUp, null) : /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronDown, null),
    className: "flex grey small",
    onClick: function onClick() {
      return setRowsButtonExpanded(!rowsButtonExpanded);
    }
  }), rowsButtonExpanded ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ehrRecord ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: "as PDF",
    icon: exportCDAAsPDFLoading && exportCDAAsPDFLoading[3] ? /*#__PURE__*/_react.default.createElement(_reactFeather.RotateCw, {
      style: {
        animation: "spin 1.5s linear infinite"
      }
    }) : /*#__PURE__*/_react.default.createElement(_reactFeather.Download, null),
    className: "flex grey small sub",
    onClick: function onClick() {
      return exportAsPDF({
        rows: rowsToExport
      }, 3);
    },
    disabled: exportCDAAsPDFLoading && Object.keys(exportCDAAsPDFLoading).find(function (i) {
      return exportCDAAsPDFLoading[i] === true;
    })
  }), /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: "as PDF with RAF",
    icon: exportCDAAsPDFLoading && exportCDAAsPDFLoading[4] ? /*#__PURE__*/_react.default.createElement(_reactFeather.RotateCw, {
      style: {
        animation: "spin 1.5s linear infinite"
      }
    }) : /*#__PURE__*/_react.default.createElement(_reactFeather.Download, null),
    className: "flex grey small sub",
    onClick: function onClick() {
      return exportAsPDF({
        withRaf: true,
        rows: rowsToExport
      }, 4);
    },
    disabled: exportCDAAsPDFLoading && Object.keys(exportCDAAsPDFLoading).find(function (i) {
      return exportCDAAsPDFLoading[i] === true;
    })
  })) : null, /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: "as CCD XML",
    icon: /*#__PURE__*/_react.default.createElement(_reactFeather.Download, null),
    className: "flex grey small sub",
    onClick: function onClick() {
      return downloadRowsAsXML(rawDocument, rowsToExport);
    },
    disabled: exportCDAAsPDFLoading && Object.keys(exportCDAAsPDFLoading).find(function (i) {
      return exportCDAAsPDFLoading[i] === true;
    })
  })) : null, /*#__PURE__*/_react.default.createElement(_components.Button, {
    text: "Reset row selection",
    className: "flex grey small reset-button",
    onClick: function onClick() {
      resetRowsSelection();
      setRowsButtonExpanded(false);
    }
  })) : /*#__PURE__*/_react.default.createElement("h5", null, "...")) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "sidebar-body ".concat(ehrRecord ? '' : 'full')
  }, expanded || menuHover ? /*#__PURE__*/_react.default.createElement("h5", null, "Table of Contents") : /*#__PURE__*/_react.default.createElement("h5", null, "..."), /*#__PURE__*/_react.default.createElement("ul", null, tocData && tocData.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: i
    }, /*#__PURE__*/_react.default.createElement(_reactScroll.Link, {
      to: item,
      activeClass: "active",
      offset: -250,
      smooth: true,
      spy: true,
      isDynamic: true,
      onClick: function onClick() {
        return closeMobileMenu();
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "nav-icon"
    }, /*#__PURE__*/_react.default.createElement(_components.Icon, {
      title: item
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "nav-text"
    }, item)));
  })))));
};

var _default = Sidebar;
exports.default = _default;